angular.module('mobilezuz').controller('OrderFinishedText', ['$scope', 'mDesign', 'orderFinishedText',
    function ($scope, mDesign, orderFinishedText) {
        $scope.dialog = mDesign;
        $scope.orderFinishedText = orderFinishedText;
    }]);